import Store from "../../../../Store/Store";

class SubscriptionTypeContainer {
  public pickIdFromLabel(label) {
    const chargeClass = Store.getConfigurator().getState().globalTypes?.SubscriptionType;
    for(const key in chargeClass) {
      if (chargeClass[key].label === label) {
        return chargeClass[key].id
      }
    }
  }
}

export default new SubscriptionTypeContainer();
